import React from 'react';
import { Button } from '/imports/ui/Button';
import { panelSurface } from '/imports/ui/Panel';

/**
 * Shared chrome for the devtools.
 *
 * Every tool used to carry its own `inputStyle` object -- five verbatim copies
 * of `border: '1px solid #ccc'` with a hardcoded light result panel. With
 * preflight off those rendered as UA-styled white boxes with black text, which
 * is invisible-on-invisible in Obsidian. These constants are the console's own
 * tokens, so the tools follow the theme like everything else.
 *
 * Text, select and textarea controls now use the kit (Input/Select/TextArea).
 * These remain for the two things the kit does not cover: file inputs and the
 * result panels.
 */
export const devFieldStack = 'mt-3 flex flex-col gap-3';
export const devLabel = 'mb-1.5 block text-[12px] font-semibold text-fg-2';
export const devResultPanel = 'mt-4 rounded-card border border-soft bg-page-alt px-4 py-3 text-[13px]';
export const devHint = 'mt-1 text-[12px] text-fg-3';
export const devCheckRow = 'flex flex-wrap gap-x-6 gap-y-2';
export const devCheckLabel = 'flex items-center gap-2 text-[13px] text-fg-1';
export const devFileInput = 'w-full cursor-pointer rounded-md border border-mid bg-panel px-3 py-2 text-[13px] text-fg-1 file:mr-3 file:cursor-pointer file:rounded file:border-0 file:bg-page-alt file:px-3 file:py-1 file:text-[12px] file:font-semibold file:text-fg-2';
export const devMono = 'font-mono tabular-nums';

interface DevToolSectionProps {
  title?: string;
  description?: string;
  onRun?(): void;
  buttonText?: string;
  loading?: boolean;
  children?: React.ReactNode;
}

export const DevToolSection = (props: DevToolSectionProps) => {
  return (
    <section className={`${panelSurface} p-4`}>
      {props.title && <h2>{props.title}</h2> || null}
      {props.description && <p className="mt-1 mb-3 text-[13px] text-fg-2" dangerouslySetInnerHTML={{ __html: props.description }} /> || null}
      {
        props.onRun ?
          <div>
            <Button onClick={() => props.onRun?.()} disabled={props.loading}>{props.loading ? 'Running...' : (props.buttonText || 'Run')}</Button>
          </div>
          :
          null
      }
      {props.children || null}
    </section>
  );
};

